module.exports = __webpack_public_path__ + "static/media/google-pay.716e047e.png";